/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { LoginService } from 'src/app/services/login/login.service';
import OneSignal from 'onesignal-cordova-plugin';
import { environment } from 'src/environments/environment';
import { Platform } from '@ionic/angular';

interface Data {
  type: string;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  loginForm: FormGroup;
  passwordType = 'password';
  passwordIcon = 'eye';
  btnClicked = false;
  from;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private route: ActivatedRoute,
    // private oneSignal: OneSignal,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.from = params.from;
    });
    this.loginForm = this.formBuilder.group({
      accountType: ['', Validators.required],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  login() {
    this.btnClicked = true;
    if (this.loginForm.valid === true) {
      const { accountType, email, password } = this.loginForm.value;
      let collection = '';
      let route = '';

      if (accountType === 'User') {
        collection = 'Users';
        if (this.from) {
          route = this.from;
        } else {
          route = 'user-home';
        }
      } else if (accountType === 'Driver') {
        collection = 'Drivers';
        route = 'driver-home';
      } else if (accountType === 'Store') {
        collection = 'Stores';
        route = 'store-home';
        console.log(route);
      } else if (accountType === 'Call-Agent') {
        collection = 'CallAgents';
        route = 'call-agent-home';
      }
      if (collection) {
        const lowCapsEmail = email.toLowerCase();
        this.loginService
          .checkUser(collection, lowCapsEmail)
          .subscribe((data) => {
            if (!data.empty) {
              this.loginService
                .login(email, password)
                .then((res) => {
                  const uid = res.user.uid;
                  if (accountType === 'Driver') {
                    // this.oneSignalInit(uid);
                    if (
                      this.platform.is('desktop') ||
                      this.platform.is('mobileweb')
                    ) {
                    } else {
                      this.oneSignalInit(uid);
                    }
                  }

                  if (accountType === 'Store') {
                    // this.oneSignalInit(uid);
                    if (
                      this.platform.is('desktop') ||
                      this.platform.is('mobileweb')
                    ) {
                    } else {
                      this.oneSignalInitStore(uid);
                    }
                  }

                  if (accountType === 'Call-Agent') {
                    // this.oneSignalInit(uid);
                    if (
                      this.platform.is('desktop') ||
                      this.platform.is('mobileweb')
                    ) {
                    } else {
                      this.oneSignalInitAgent(uid);
                    }
                  }

                  this.btnClicked = false;
                  this.loginForm.reset();
                  this.router.navigate([route]);
                })
                .catch((error) => {
                  this.btnClicked = false;
                  alert(error.message);
                });
            } else {
              this.btnClicked = false;
              alert('Invalid Credentials');
            }
          });
      } else {
        this.btnClicked = false;
        alert('Error');
      }
    }
  }

  oneSignalInit(uid) {
    // Uncomment to set OneSignal device logging to VERBOSE
    // OneSignal.setLogLevel(6, 0);

    // NOTE: Update the setAppId value below with your OneSignal AppId.
    OneSignal.setAppId(environment.oneSignalKey);

    OneSignal.setExternalUserId(uid);

    OneSignal.getDeviceState((res) => {
      const playerID = res.userId;
      this.loginService.setDriverPlayerID(uid, playerID);
    });

    OneSignal.sendTags({ driver: true });

    OneSignal.setNotificationOpenedHandler((jsonData) => {
      // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      // alert('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      const data = jsonData.notification.additionalData as Data;

      if (data.type === 'user-delivery-type') {
        this.router.navigate(['/driver-request']);
      }
    });

    // iOS - Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead
    //    using an In-App Message to prompt for notification permission
    //    (See step 6) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
      // console.log('User accepted notifications: ' + accepted);
      // alert('User accepted notifications: ' + accepted);
    });

    // this.oneSignal.startInit(environment.oneSignalKey);
    // // this.oneSignal.setExternalUserId(uid);
    // // this.oneSignal.sendTags({ driver: true });
    // this.oneSignal.inFocusDisplaying(
    //   this.oneSignal.OSInFocusDisplayOption.InAppAlert
    // );

    // this.oneSignal.handleNotificationReceived().subscribe((res) => {
    //   // do something when notification is received
    //   alert('[received] === ' + JSON.stringify(res));
    // });

    // this.oneSignal.handleNotificationOpened().subscribe((res) => {
    //   // do something when a notification is opened
    //   alert('[opened] === ' + JSON.stringify(res));
    // });

    // this.oneSignal.endInit();
  }

  oneSignalInitStore(uid) {
    OneSignal.setAppId(environment.oneSignalKey);

    OneSignal.setExternalUserId(uid);

    OneSignal.getDeviceState((res) => {
      const playerID = res.userId;
      this.loginService.setStorePlayerID(uid, playerID);
    });

    OneSignal.sendTags({ store: true });

    OneSignal.setNotificationOpenedHandler((jsonData) => {
      // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      // alert('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      const data = jsonData.notification.additionalData as Data;
    });

    // iOS - Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead
    //    using an In-App Message to prompt for notification permission
    //    (See step 6) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
      // console.log('User accepted notifications: ' + accepted);
      // alert('User accepted notifications: ' + accepted);
    });
  }

  oneSignalInitAgent(uid) {
    OneSignal.setAppId(environment.oneSignalKey);

    OneSignal.setExternalUserId(uid);

    OneSignal.getDeviceState((res) => {
      const playerID = res.userId;
      this.loginService.setAgentPlayerID(uid, playerID);
    });

    OneSignal.sendTags({ store: true });

    OneSignal.setNotificationOpenedHandler((jsonData) => {
      // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      // alert('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      const data = jsonData.notification.additionalData as Data;
    });

    // iOS - Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead
    //    using an In-App Message to prompt for notification permission
    //    (See step 6) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
      // console.log('User accepted notifications: ' + accepted);
      // alert('User accepted notifications: ' + accepted);
    });
  }

  register() {
    this.router.navigate(['home/register']);
  }

  home() {
    this.router.navigate(['home/landing']);
  }

  about() {
    this.router.navigate(['home/about']);
  }

  track() {
    this.router.navigate(['track-order']);
  }

  cart() {
    this.router.navigate(['home/cart']);
  }

  logins() {
    this.router.navigate(['user-home']);
  }
  allshops() {
    this.router.navigate(['all-shops']);
  }

  admin() {
    this.router.navigate(['admin-home']);
  }

  driver() {
    this.router.navigate(['driver-home']);
  }

  store() {
    this.router.navigate(['store-home']);
  }
}
